import { loader } from 'graphql.macro'

export default async function removeImageFromTicket ({ dataLoaders, variables }) {
  const schema = loader('./removeImageFromTicket.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, { input: variables })
  return response.deleteImageFromTicket
}
